import { render, staticRenderFns } from "./main.vue?vue&type=template&id=607c76da&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=607c76da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c76da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('607c76da')) {
      api.createRecord('607c76da', component.options)
    } else {
      api.reload('607c76da', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=607c76da&scoped=true", function () {
      api.rerender('607c76da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Uploads/Image/main.vue"
export default component.exports